export default __webpack_public_path__ + "images/3afe26d1a532c51edbb665b8fc11d17e-democratic_party_small.webp";